//core
import React from "react";
import { useTranslation } from "react-i18next";
import arePropsEqual from "react-fast-compare";
import { Chip } from "@mui/material";

import {
  indigo,
  deepOrange,
  lightBlue,
  purple, common
} from "@mui/material/colors";

interface ITransactionTypeProps {
  value: string;
}

const TransactionType = ({ value }: ITransactionTypeProps) => {
  const {t} = useTranslation();

  return (
    <>
      { value === 'transfer' && <Chip size="small" label={t("common.components.transaction.type.transfer")} color="primary" sx={{ backgroundColor: indigo[500] }} />}
      { value === 'system' && <Chip size="small" label={t("common.components.transaction.type.system")} color="primary" sx={{ backgroundColor: deepOrange[500] }} />}
      { value === 'deposit' && <Chip size="small" label={t("common.components.transaction.type.deposit")} color="primary" sx={{ backgroundColor: lightBlue[500] }} />}
      { value === 'withdraw' && <Chip size="small" label={t("common.components.transaction.type.withdraw")} color="primary" sx={{ backgroundColor: purple[500] }} />}
    </>
  );
};

export default React.memo(TransactionType, arePropsEqual)
